module.exports = __webpack_public_path__ + "img/vip-mobile-3.c14f3d20.jpeg";